(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (() => {
    const scrollToHashTarget = () => {
      const hash = window.location.hash;

      if (!hash || hash === '#') return;

      const id = decodeURIComponent(hash.slice(1));
      const card = document.getElementById(id);

      if (!card) return;

      /*
       * Use the browser's native non-animated behaviour.
       * This avoids the non-standard "instant" scroll behaviour.
       */
      card.scrollIntoView({
        behavior: 'auto',
        block: 'start',
      });

      /*
       * If the target can receive focus, move focus without causing
       * another scroll. This improves keyboard and assistive technology
       * navigation without changing the visual position.
       */
      if (typeof card.focus === 'function') {
        const hadTabIndex = card.hasAttribute('tabindex');

        if (!hadTabIndex) {
          card.setAttribute('tabindex', '-1');
        }

        card.focus({ preventScroll: true });

        if (!hadTabIndex) {
          card.addEventListener(
            'blur',
            () => card.removeAttribute('tabindex'),
            { once: true }
          );
        }
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scrollToHashTarget, {
        once: true,
      });
    } else {
      scrollToHashTarget();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
